import { c as _c } from "react/compiler-runtime";
import { getLogger } from '@onefootprint/logger';
import type React from 'react';
import { ErrorBoundary as RErrorBoundary } from 'react-error-boundary';
import ErrorComponent from './components/error';
export type ErrorBoundaryProps = {
  children: React.ReactNode;
};
const {
  logError
} = getLogger({
  location: 'app-error-boundary'
});
const ErrorBoundary = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <RErrorBoundary FallbackComponent={ErrorComponent} onError={_temp}>{children}</RErrorBoundary>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ErrorBoundary;
function _temp(error, info) {
  logError("Dashboard render error", error, {
    componentStack: info.componentStack?.slice(0, 100)
  });
}